import { store } from '../../store';
import * as ACTIONS from './actions';

const obj = {
    // checkUser:(data) => store.dispatch(ACTIONS.checkUser(data))

}

export default obj;